import React from 'react';
import ReportDataPage from './ReportDataPage';

const cols = [
  { key: 'transactionId', header: 'Transaction ID' },
  { key: 'status', header: 'Status' },
  { key: 'itemCount', header: 'Items' },
  {
    key: 'completedAt',
    header: 'Completed',
    format: (v) => (v ? new Date(v).toLocaleString() : ''),
  },
];

export default function OrderPickingReport() {
  return (
    <ReportDataPage
      title="Order picking report"
      subtitle="Completed picking sessions recorded from mobile (order management / fulfillment)."
      endpoint="/api/reports/order-picking-records"
      exportFileSlug="order-picking-report"
      columns={cols}
      emptyIcon="📋"
    />
  );
}
